import { Link } from "react-router";
import SceneView from "../components/three/SceneView";
import SectionLabel from "../components/SectionLabel";
import ExternalLink from "../components/ExternalLink";
import { Arrow } from "../components/Icons";
import { projects } from "../data/projects";
export default function AeroFeature() {
  return (
    <section
      className="aero-feature container section"
      aria-labelledby="aero-feature-title"
    >
      <div className="feature-copy">
        <SectionLabel index="In focus">AERO/01</SectionLabel>
        <h2 id="aero-feature-title">
          Beyond the
          <br />
          flat screen.
        </h2>
        <p>
          I built AERO/01 around a running shoe you can turn and inspect.
          Try the model here, or open the project to see how it came together.
        </p>
        <ul className="feature-list">
          <li>Rotate and inspect the shoe</li>
          <li>Use touch, a mouse, or the controls</li>
          <li>Switch to a still image at any time</li>
        </ul>
        <div className="feature-links">
          <Link className="text-link" to="/work/aero-01">
            Inside the project <Arrow diagonal />
          </Link>
          <ExternalLink href={projects[0].liveUrl} event="live_site_click">
            Full experience
          </ExternalLink>
        </div>
        <p className="fine-print">Self-initiated fictional product concept.</p>
      </div>
      <div className="feature-view">
        <span className="mono feature-view-label">AERO/01 · Bone / Silver</span>
        <SceneView kind="shoe" />
        <span className="mono feature-view-bottom">
          Original Blender model / Studio preview
        </span>
      </div>
    </section>
  );
}
